<template>
  <v-app>
    <v-main>
      <v-container fluid class="pa-0" fill-height>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="sass">
  @import 'assets/styles/styles.scss'
</style>
<script>
export default {
  data () {
    return {
    };
  },
  beforeCreate () {
    const th = this
    if (location.pathname !== '/home' && localStorage.status === 'loggedIn') {
      var test = th.$store.state.magalupay.dadosIniciais
      if (test && Object.keys(test).length === 0) {
        th.$router.goToHome()
      }
    }
  },
  created () {
    const vm = this
    if (localStorage.status === 'loggedIn' && location.pathname) {
      const regex = /\/?auth\/?/gm;
      if (regex.test(location.pathname) && location.search.indexOf('?token=') >= 0) {
        vm.$api.UTIL.Auth.Logout()
      }
    }
  }
};
</script>
